<template>
  <section class="px-5 pb-5">
    <CCol v-if="messages.length" sm="12" class="mt-3">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </CCol>
    <CAlert class="mt-5 ml-5 mr-5 mb-0 font-sm" color="info">
      <div class="d-flex align-items-baseline text-black">
        <div>
          <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="15" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
        </div>
        <p class="mb-0">
          {{ $t('manageplan.component.card.payment-method-alert') }}
        </p>
      </div>
    </CAlert>
    <CForm role="group" class="form-group mb-3 px-5 mt-5">
      <p class="mb-4 font-weight-bold">
        <CIcon name="creditCard" class="mx-1" size="custom-size" :height="25" viewBox="0 0 32 32" />
        {{ $t(`manageBalance.paymentMethod.subTitle`) }}
      </p>

      <div class="mb-2" v-if="customer.card">
        <label>
          {{ $t(`manageBalance.paymentMethod.paymentMethodLabel`) }}
        </label>

        <v-select
          v-model="selectedPayment"
          class="selectCountry newInput no-close mb-0 px-3"
          :options="options"
          ref="countrySelect"
          custom
          autoscroll
          :placeholder="$t(`manageBalance.paymentMethod.placeHolder`)"
          @input="selectMethod"
        >
          <template v-slot:option="option" class="py-4 px-2 d-flex justify-content-between">
            <CIcon :name="option.brand" size="custom-size" :height="30" viewBox="0 0 32 32" />
            <span class="ml-2">
              {{ option.label }}
            </span>
            <span class="ml-2" v-if="option.expMonth"> {{ option.expMonth }} / {{ option.expYear }} </span>
          </template>
        </v-select>
      </div>
      <div v-if="selectedPayment && selectedPayment.iframe">
        <CInput
          type="text"
          class="newInput nameCard"
          :class="{ error: hasErrorName }"
          :label="$t(`manageBalance.paymentMethod.name`)"
          aria-placeholder="name"
          :placeholder="$t(`manageBalance.paymentMethod.name`)"
          v-model="name"
          :add-input-classes="{ error: hasErrorName }"
          ref="inputName"
          @focus="focus"
        />
        <p class="p-0" v-if="hasErrorName" :class="{ error: hasErrorName }" role="alert">
          {{ $t(`manageBalance.paymentMethod.messageErrorNameCard`) }}
        </p>
      </div>
    </CForm>
    <div ref="card" class="px-5"></div>

    <div class="d-flex justify-content-end px-5 mt-3">
      <CButton class="font-base btn btn-outline-light text-gray-600 px-5 py-3" @click="prev">
        {{ $t('manageplan.component.card.payment-method.button.back') }}
      </CButton>
      <CButton color="primary" class="font-base ml-3 px-5 py-3" @click="confirmSetup" :disabled="!selectedPayment">
        <span class="px-5">
          {{ $t('manageplan.component.card.payment-method.button.next') }}
        </span>
      </CButton>
    </div>
  </section>
</template>

<script>
import vSelect from 'vue-select'
import MenssageAlert from '@/components/MenssageAlert'

export default {
  components: {
    vSelect,
    MenssageAlert,
  },
  props: {
    cartPackges: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      stripe: null,
      elements: null,
      card: null,
      organizationId: null,
      host: window.location.host,
      protocol: window.location.protocol,
      appearance: {
        theme: 'stripe',

        rules: {
          '.Label': {
            fontSize: '1rem',
            fontWeight: 'semibold',
          },
        },

        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#ffffff',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: 'Nunito Sans, system-ui, sans-serif',
          spacingUnit: '6px',
          borderRadius: '4px',
        },
      },
      path: this.$route.path,
      selectedPayment: this.$store.state.balance.steps.selectPayment || null,
      billingInfo: null,
      customer: null,
      planId: this.$store.state.balance.steps.selectedPlanId,
      tierId: this.$store.state.balance.steps.selectedTierId,
      period: this.$store.state.balance.steps.paymentPeriod,
      selectedPayment: this.$store.state.balance.steps.selectPayment || null,
      hasErrorName: false,
      name: '',
      messages: [],
    }
  },

  created() {
    this.customer = this.$store.state.balance.steps.customer
    this.organizationId = this.$route.params.organizationId
    this.billingInfo = this.$store.state.balance.steps.billingInfo

    if (this.$route.query.redirect_status) {
      this.createPayment()
      const { selectedPlanId } = this.$route.query

      this.$router.replace({
        query: selectedPlanId ? { selectedPlanId } : null,
      })
      return
    }

    this.stripe = window.Stripe(this.$configs.VUE_APP_STRIPE_PK, {
      locale: this.lang.split('-')[0],
    })
  },

  mounted() {},

  destroyed() {
    if (this.card) {
      this.card.destroy(this.$refs.card)
    }
  },

  computed: {
    lang() {
      return this.$store.state.lang
    },

    options() {
      if (this.customer && this.customer.card) {
        return [
          {
            label: `**** **** **** ${this.customer.card.last4}`,
            brand: this.customer.card.brand,
            expMonth: this.customer.card.expMonth,
            expYear: this.customer.card.expYear,
            paymentId: this.customer.card.id,
            iframe: false,
            key: 'oldCard',
          },
          { label: 'new payment', brand: null, iframe: true },
        ]
      }

      return [{ label: 'new payment', brand: null, iframe: true, key: 'newCard' }]
    },
  },

  methods: {
    async confirmSetup() {
      this.messages = []

      if (!this.selectedPayment.iframe) {
        this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'selectPayment', data: this.selectedPayment }).then(() => {})
        this.createPayment()
        return
      }

      const queryString = new URLSearchParams(this.$route.query).toString()

      const result = await this.stripe.confirmSetup({
        elements: this.elements,
        confirmParams: {
          return_url: `${this.protocol}//${this.host}${this.path}?${queryString}`,
          payment_method_data: {
            billing_details: {
              name: this.name,
            },
          },
        },
      })
      console.log('erro types', result.error.code)

      let errorMessage

      if (result.error) {
        switch (result.error.code) {
          case 'card_declined':
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
            break
          case 'expired_card':
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
            break
          case 'incorrect_cvc':
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
            break
          case 'processing_error':
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
            break
          case 'incorrect_number':
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
            break
          default:
            this.messages.push({
              status: 'danger',
              text: result.error.message,
            })
        }

        return
      }

      if (result.error) {
        switch (result.error.type) {
          case 'StripeCardError':
            // A declined card error
            // result.error.message // => e.g. "Your card's expiration year is invalid."
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeRateLimitError':
            // Too many requests made to the API too quickly
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeInvalidRequestError':
            // Invalid parameters were supplied to Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAPIError':
            // An error occurred internally with Stripe's API
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeConnectionError':
            // Some kind of error occurred during the HTTPS communication
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'validation_error':
            // You probably used an incorrect API key
            console.log('error', result.error.message)
            errorMessage = result.error.message
            this.hasErrorName = true
            break
          case 'invalid_request_error':
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          case 'StripeAuthenticationError':
            // You probably used an incorrect API key
            console.log('error', result.error.message)
            errorMessage = result.error.message
            break
          default:
            // Handle any other types of unexpected errors
            throw new Error(result)
        }

        this.messages.push({
          status: 'danger',
          text: errorMessage || 'erro',
        })
        return
      }
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'selectPayment', data: this.selectedPayment })
      this.$store.dispatch('balance/steps/setCurrentStep', 4)
    },

    async pay() {
      const setupIntent = await this.stripe.confirmCardPayment('pi_3LTUa7E16FYrcGYs1OpPASdQ_secret_HO5kW6BPUva3ckz0LJJpzz31j', {
        payment_method: 'pi_3LUuAQE16FYrcGYs1nm00WK5',
      })
    },

    focus() {
      this.hasErrorName = false
    },

    prev() {
      this.$store.dispatch('balance/steps/setCurrentStep', 2)
    },

    selectMethod(event) {
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'selectPayment', data: event })

      if (!event.iframe) {
        if (this.card) {
          this.card.destroy(this.$refs.card)
        }
        return
      }

      this.mountIframeStripe()
    },

    mountIframeStripe() {
      this.elements = this.stripe.elements({
        clientSecret: this.customer.setupSecret,
        appearance: this.appearance,
      })

      this.card = this.elements.create('payment', {
        fields: {
          billingDetails: {
            name: 'auto',
          },
        },
      })

      this.card.mount(this.$refs.card)
    },

    createPayment() {
      let countryDetail = null
      if (this.billingInfo.countryId == 'PT' && this.billingInfo.detailCountry === undefined) {
        countryDetail = 'portugal'
      } else {
        countryDetail = this.billingInfo.detailCountry || null
      }

      console.log(this.$route.query.setup_intent, 'query.setup_intent')
      let intent = this.$route.query.setup_intent || null
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'setupIntent', data: intent })

      this.$store.dispatch('balance/steps/balancetax', {
        info: {
          vatNumber: this.billingInfo.taxIdentificationNumber, //OK
          period: this.period, //OK
          paymentId: this.selectedPayment.paymentId || null, //OK
          setupIntent: this.$route.query.setup_intent || null, //NULO //NULLABLE //SETUP INTENT É SÓ PRA CARTÃO NOVO
          stripePaymentMethodId: this.selectedPayment.paymentId || null, //NULO // É O ID DO CARD SELECIONADO E RETORNADO NO VALIDADE BILLING INFO //nullable
          detailCountry: countryDetail, //NULO //label do select Açores/Portugal/Madeira
          countryId: this.billingInfo.countryId, //NULO //é o codigo do pais selecionado no billinginfo
          setupIntentClientSecret: this.$route.query.setup_intent_client_secret || this.customer.setupSecret, //OK
          addOnEmails: this.getSelectedAddonsByChannel('email'),
          addOnSmss: this.getSelectedAddonsByChannel('sms'),
        },
        organizationId: this.organizationId,
      })
    },

    getSelectedAddonsByChannel(channel) {
      let emails = this.cartPackges.filter((item) => item.channel == channel)
      let selectedAddonsByChannel = []

      emails.forEach((elm) => {
        selectedAddonsByChannel.push({
          id: elm.package.packSelected.id,
          quantity: elm.quantity,
        })
      })

      return selectedAddonsByChannel
    },
  },

  watch: {
    lang(newValue) {
      this.card = this.elements.update({ locale: newValue.split('-')[0] })
    },

    options(newValue, oldValue) {
      this.selectedPayment = newValue[0] || null
    },

    selectedPayment(newValue) {
      if (newValue.iframe) {
        this.mountIframeStripe()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-size {
  width: 200px;
  background: red;
}

#custom-button {
  height: 30px;
  outline: 1px solid grey;
  background-color: green;
  padding: 5px;
  color: white;
}

.form-group.error {
  margin-bottom: 5px !important;
}

.form-group.error input {
  border-width: 2px !important;
  border-color: #df1b41 !important;
}

form.form-group .nameCard input.form-control:focus {
  outline: 0 !important;
  border-width: 1px !important;
  border-color: #0573e180 !important;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02), 0 0 0 3px #0573e140, 0 1px 1px 0 #00000014 !important;
}

p.error {
  color: #df1b41;
}
</style>
